import { ETheme } from "@/common/entity/Enum";
import { renderBackgroundColorByTheme, renderColorByTheme } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const BaseParentWrapper = styled.div<{ $theme?: string }>`
  height: calc(100vh - 35px);
  overflow-y: auto;
  background-color: ${props => props.$theme === ETheme.Dark ? ETheme.Dark : "#e7f0f8"};
  &::-webkit-scrollbar {
    position: sticky;
    width: 3px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
export const BaseWrapper = styled.div<{ $theme?: string }>`
  position: relative;
  padding-left: 4px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    position: sticky;
    width: 3px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .ms-Grid {
    box-sizing: border-box;
    zoom: 1;
    padding: 0 8px;
  }

  .ms-Grid::before,
  .ms-Grid::after {
    display: table;
    content: "";
    line-height: 0;
  }

  .ms-Grid::after {
    clear: both;
  }

  .ms-Grid-row {
    margin: 0 -8px;
    box-sizing: border-box;
    zoom: 1;
  }

  .ms-Grid-row::before,
  .ms-Grid-row::after {
    display: table;
    content: "";
    line-height: 0;
  }

  .ms-Grid-row::after {
    clear: both;
  }

  .ms-Grid-col {
    position: relative;
    min-height: 1px;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
  }

  [dir="ltr"] .ms-Grid-col {
    float: left;
  }

  [dir="rtl"] .ms-Grid-col {
    float: right;
  }

  .ms-Grid-col .ms-Grid {
    padding: 0;
  }

  /*
  Your use of the content in the files referenced here are subject to the terms of the license at http://aka.ms/fabric-font-license
*/
  @font-face {
    font-family: "FabricMDL2Icons";
    src: url("https://static2.sharepointonline.com/files/fabric/assets/icons/fabricmdl2icons-3.54.woff")
      format("woff");
    font-weight: normal;
    font-style: normal;
  }

  @media (max-width: 479.99999px) {
    .ms-hiddenSm,
    .ms-hiddenMdDown,
    .ms-hiddenLgDown,
    .ms-hiddenXlDown,
    .ms-hiddenXxlDown {
      display: none !important;
    }
  }

  @media (min-width: 480px) and (max-width: 639.99999px) {
    .ms-hiddenMd,
    .ms-hiddenMdUp,
    .ms-hiddenMdDown,
    .ms-hiddenLgDown,
    .ms-hiddenXlDown,
    .ms-hiddenXxlDown {
      display: none !important;
    }
  }

  @media (min-width: 640px) and (max-width: 1023.99999px) {
    .ms-hiddenMdUp,
    .ms-hiddenLg,
    .ms-hiddenLgUp,
    .ms-hiddenLgDown,
    .ms-hiddenXlDown,
    .ms-hiddenXxlDown {
      display: none !important;
    }
  }

  @media (min-width: 1024px) and (max-width: 1365.99999px) {
    .ms-hiddenMdUp,
    .ms-hiddenLgUp,
    .ms-hiddenXl,
    .ms-hiddenXlUp,
    .ms-hiddenXlDown,
    .ms-hiddenXxlDown {
      display: none !important;
    }
  }

  @media (min-width: 1366px) and (max-width: 1919.99999px) {
    .ms-hiddenMdUp,
    .ms-hiddenLgUp,
    .ms-hiddenXlUp,
    .ms-hiddenXxl,
    .ms-hiddenXxlUp,
    .ms-hiddenXxlDown {
      display: none !important;
    }
  }

  @media (min-width: 1920px) {
    .ms-hiddenMdUp,
    .ms-hiddenLgUp,
    .ms-hiddenXlUp,
    .ms-hiddenXxlUp,
    .ms-hiddenXxxl {
      display: none !important;
    }
  }

  .ms-sm12 {
    width: 100%;
  }

  .ms-sm11 {
    width: 91.66666666666666%;
  }

  .ms-sm10 {
    width: 83.33333333333334%;
  }

  .ms-sm9 {
    width: 75%;
  }

  .ms-sm8 {
    width: 66.66666666666666%;
  }

  .ms-sm7 {
    width: 58.333333333333336%;
  }

  .ms-sm6 {
    width: 50%;
  }

  .ms-sm5 {
    width: 41.66666666666667%;
  }

  .ms-sm4 {
    width: 33.33333333333333%;
  }

  .ms-sm3 {
    width: 25%;
  }

  .ms-sm2 {
    width: 16.666666666666664%;
  }

  .ms-sm1 {
    width: 8.333333333333332%;
  }

  [dir="ltr"] .ms-smPull12 {
    right: 100%;
  }

  [dir="rtl"] .ms-smPull12 {
    left: 100%;
  }

  [dir="ltr"] .ms-smPull11 {
    right: 91.66667%;
  }

  [dir="rtl"] .ms-smPull11 {
    left: 91.66667%;
  }

  [dir="ltr"] .ms-smPull10 {
    right: 83.33333%;
  }

  [dir="rtl"] .ms-smPull10 {
    left: 83.33333%;
  }

  [dir="ltr"] .ms-smPull9 {
    right: 75%;
  }

  [dir="rtl"] .ms-smPull9 {
    left: 75%;
  }

  [dir="ltr"] .ms-smPull8 {
    right: 66.66667%;
  }

  [dir="rtl"] .ms-smPull8 {
    left: 66.66667%;
  }

  [dir="ltr"] .ms-smPull7 {
    right: 58.33333%;
  }

  [dir="rtl"] .ms-smPull7 {
    left: 58.33333%;
  }

  [dir="ltr"] .ms-smPull6 {
    right: 50%;
  }

  [dir="rtl"] .ms-smPull6 {
    left: 50%;
  }

  [dir="ltr"] .ms-smPull5 {
    right: 41.66667%;
  }

  [dir="rtl"] .ms-smPull5 {
    left: 41.66667%;
  }

  [dir="ltr"] .ms-smPull4 {
    right: 33.33333%;
  }

  [dir="rtl"] .ms-smPull4 {
    left: 33.33333%;
  }

  [dir="ltr"] .ms-smPull3 {
    right: 25%;
  }

  [dir="rtl"] .ms-smPull3 {
    left: 25%;
  }

  [dir="ltr"] .ms-smPull2 {
    right: 16.66667%;
  }

  [dir="rtl"] .ms-smPull2 {
    left: 16.66667%;
  }

  [dir="ltr"] .ms-smPull1 {
    right: 8.33333%;
  }

  [dir="rtl"] .ms-smPull1 {
    left: 8.33333%;
  }

  [dir="ltr"] .ms-smPull0 {
    right: auto;
  }

  [dir="rtl"] .ms-smPull0 {
    left: auto;
  }

  [dir="ltr"] .ms-smPush12 {
    left: 100%;
  }

  [dir="rtl"] .ms-smPush12 {
    right: 100%;
  }

  [dir="ltr"] .ms-smPush11 {
    left: 91.66667%;
  }

  [dir="rtl"] .ms-smPush11 {
    right: 91.66667%;
  }

  [dir="ltr"] .ms-smPush10 {
    left: 83.33333%;
  }

  [dir="rtl"] .ms-smPush10 {
    right: 83.33333%;
  }

  [dir="ltr"] .ms-smPush9 {
    left: 75%;
  }

  [dir="rtl"] .ms-smPush9 {
    right: 75%;
  }

  [dir="ltr"] .ms-smPush8 {
    left: 66.66667%;
  }

  [dir="rtl"] .ms-smPush8 {
    right: 66.66667%;
  }

  [dir="ltr"] .ms-smPush7 {
    left: 58.33333%;
  }

  [dir="rtl"] .ms-smPush7 {
    right: 58.33333%;
  }

  [dir="ltr"] .ms-smPush6 {
    left: 50%;
  }

  [dir="rtl"] .ms-smPush6 {
    right: 50%;
  }

  [dir="ltr"] .ms-smPush5 {
    left: 41.66667%;
  }

  [dir="rtl"] .ms-smPush5 {
    right: 41.66667%;
  }

  [dir="ltr"] .ms-smPush4 {
    left: 33.33333%;
  }

  [dir="rtl"] .ms-smPush4 {
    right: 33.33333%;
  }

  [dir="ltr"] .ms-smPush3 {
    left: 25%;
  }

  [dir="rtl"] .ms-smPush3 {
    right: 25%;
  }

  [dir="ltr"] .ms-smPush2 {
    left: 16.66667%;
  }

  [dir="rtl"] .ms-smPush2 {
    right: 16.66667%;
  }

  [dir="ltr"] .ms-smPush1 {
    left: 8.33333%;
  }

  [dir="rtl"] .ms-smPush1 {
    right: 8.33333%;
  }

  [dir="ltr"] .ms-smPush0 {
    left: auto;
  }

  [dir="rtl"] .ms-smPush0 {
    right: auto;
  }

  [dir="ltr"] .ms-smOffset11 {
    margin-left: 91.66667%;
  }

  [dir="rtl"] .ms-smOffset11 {
    margin-right: 91.66667%;
  }

  [dir="ltr"] .ms-smOffset10 {
    margin-left: 83.33333%;
  }

  [dir="rtl"] .ms-smOffset10 {
    margin-right: 83.33333%;
  }

  [dir="ltr"] .ms-smOffset9 {
    margin-left: 75%;
  }

  [dir="rtl"] .ms-smOffset9 {
    margin-right: 75%;
  }

  [dir="ltr"] .ms-smOffset8 {
    margin-left: 66.66667%;
  }

  [dir="rtl"] .ms-smOffset8 {
    margin-right: 66.66667%;
  }

  [dir="ltr"] .ms-smOffset7 {
    margin-left: 58.33333%;
  }

  [dir="rtl"] .ms-smOffset7 {
    margin-right: 58.33333%;
  }

  [dir="ltr"] .ms-smOffset6 {
    margin-left: 50%;
  }

  [dir="rtl"] .ms-smOffset6 {
    margin-right: 50%;
  }

  [dir="ltr"] .ms-smOffset5 {
    margin-left: 41.66667%;
  }

  [dir="rtl"] .ms-smOffset5 {
    margin-right: 41.66667%;
  }

  [dir="ltr"] .ms-smOffset4 {
    margin-left: 33.33333%;
  }

  [dir="rtl"] .ms-smOffset4 {
    margin-right: 33.33333%;
  }

  [dir="ltr"] .ms-smOffset3 {
    margin-left: 25%;
  }

  [dir="rtl"] .ms-smOffset3 {
    margin-right: 25%;
  }

  [dir="ltr"] .ms-smOffset2 {
    margin-left: 16.66667%;
  }

  [dir="rtl"] .ms-smOffset2 {
    margin-right: 16.66667%;
  }

  [dir="ltr"] .ms-smOffset1 {
    margin-left: 8.33333%;
  }

  [dir="rtl"] .ms-smOffset1 {
    margin-right: 8.33333%;
  }

  [dir="ltr"] .ms-smOffset0 {
    margin-left: 0;
  }

  [dir="rtl"] .ms-smOffset0 {
    margin-right: 0;
  }

  @media (min-width: 480px) {
    .ms-md12 {
      width: 100%;
    }
  }

  @media (min-width: 480px) {
    .ms-md11 {
      width: 91.66666666666666%;
    }
  }

  @media (min-width: 480px) {
    .ms-md10 {
      width: 83.33333333333334%;
    }
  }

  @media (min-width: 480px) {
    .ms-md9 {
      width: 75%;
    }
  }

  @media (min-width: 480px) {
    .ms-md8 {
      width: 66.66666666666666%;
    }
  }

  @media (min-width: 480px) {
    .ms-md7 {
      width: 58.333333333333336%;
    }
  }

  @media (min-width: 480px) {
    .ms-md6 {
      width: 50%;
    }
  }

  @media (min-width: 480px) {
    .ms-md5 {
      width: 41.66666666666667%;
    }
  }

  @media (min-width: 480px) {
    .ms-md4 {
      width: 33.33333333333333%;
    }
  }

  @media (min-width: 480px) {
    .ms-md3 {
      width: 25%;
    }
  }

  @media (min-width: 480px) {
    .ms-md2 {
      width: 16.666666666666664%;
    }
  }

  @media (min-width: 480px) {
    .ms-md1 {
      width: 8.333333333333332%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull12 {
      right: 100%;
    }

    [dir="rtl"] .ms-mdPull12 {
      left: 100%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull11 {
      right: 91.66667%;
    }

    [dir="rtl"] .ms-mdPull11 {
      left: 91.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull10 {
      right: 83.33333%;
    }

    [dir="rtl"] .ms-mdPull10 {
      left: 83.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull9 {
      right: 75%;
    }

    [dir="rtl"] .ms-mdPull9 {
      left: 75%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull8 {
      right: 66.66667%;
    }

    [dir="rtl"] .ms-mdPull8 {
      left: 66.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull7 {
      right: 58.33333%;
    }

    [dir="rtl"] .ms-mdPull7 {
      left: 58.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull6 {
      right: 50%;
    }

    [dir="rtl"] .ms-mdPull6 {
      left: 50%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull5 {
      right: 41.66667%;
    }

    [dir="rtl"] .ms-mdPull5 {
      left: 41.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull4 {
      right: 33.33333%;
    }

    [dir="rtl"] .ms-mdPull4 {
      left: 33.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull3 {
      right: 25%;
    }

    [dir="rtl"] .ms-mdPull3 {
      left: 25%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull2 {
      right: 16.66667%;
    }

    [dir="rtl"] .ms-mdPull2 {
      left: 16.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull1 {
      right: 8.33333%;
    }

    [dir="rtl"] .ms-mdPull1 {
      left: 8.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPull0 {
      right: auto;
    }

    [dir="rtl"] .ms-mdPull0 {
      left: auto;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush12 {
      left: 100%;
    }

    [dir="rtl"] .ms-mdPush12 {
      right: 100%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush11 {
      left: 91.66667%;
    }

    [dir="rtl"] .ms-mdPush11 {
      right: 91.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush10 {
      left: 83.33333%;
    }

    [dir="rtl"] .ms-mdPush10 {
      right: 83.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush9 {
      left: 75%;
    }

    [dir="rtl"] .ms-mdPush9 {
      right: 75%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush8 {
      left: 66.66667%;
    }

    [dir="rtl"] .ms-mdPush8 {
      right: 66.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush7 {
      left: 58.33333%;
    }

    [dir="rtl"] .ms-mdPush7 {
      right: 58.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush6 {
      left: 50%;
    }

    [dir="rtl"] .ms-mdPush6 {
      right: 50%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush5 {
      left: 41.66667%;
    }

    [dir="rtl"] .ms-mdPush5 {
      right: 41.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush4 {
      left: 33.33333%;
    }

    [dir="rtl"] .ms-mdPush4 {
      right: 33.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush3 {
      left: 25%;
    }

    [dir="rtl"] .ms-mdPush3 {
      right: 25%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush2 {
      left: 16.66667%;
    }

    [dir="rtl"] .ms-mdPush2 {
      right: 16.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush1 {
      left: 8.33333%;
    }

    [dir="rtl"] .ms-mdPush1 {
      right: 8.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdPush0 {
      left: auto;
    }

    [dir="rtl"] .ms-mdPush0 {
      right: auto;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset11 {
      margin-left: 91.66667%;
    }

    [dir="rtl"] .ms-mdOffset11 {
      margin-right: 91.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset10 {
      margin-left: 83.33333%;
    }

    [dir="rtl"] .ms-mdOffset10 {
      margin-right: 83.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset9 {
      margin-left: 75%;
    }

    [dir="rtl"] .ms-mdOffset9 {
      margin-right: 75%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset8 {
      margin-left: 66.66667%;
    }

    [dir="rtl"] .ms-mdOffset8 {
      margin-right: 66.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset7 {
      margin-left: 58.33333%;
    }

    [dir="rtl"] .ms-mdOffset7 {
      margin-right: 58.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset6 {
      margin-left: 50%;
    }

    [dir="rtl"] .ms-mdOffset6 {
      margin-right: 50%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset5 {
      margin-left: 41.66667%;
    }

    [dir="rtl"] .ms-mdOffset5 {
      margin-right: 41.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset4 {
      margin-left: 33.33333%;
    }

    [dir="rtl"] .ms-mdOffset4 {
      margin-right: 33.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset3 {
      margin-left: 25%;
    }

    [dir="rtl"] .ms-mdOffset3 {
      margin-right: 25%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset2 {
      margin-left: 16.66667%;
    }

    [dir="rtl"] .ms-mdOffset2 {
      margin-right: 16.66667%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset1 {
      margin-left: 8.33333%;
    }

    [dir="rtl"] .ms-mdOffset1 {
      margin-right: 8.33333%;
    }
  }

  @media (min-width: 480px) {
    [dir="ltr"] .ms-mdOffset0 {
      margin-left: 0;
    }

    [dir="rtl"] .ms-mdOffset0 {
      margin-right: 0;
    }
  }

  @media (min-width: 640px) {
    .ms-lg12 {
      width: 100%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg11 {
      width: 91.66666666666666%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg10 {
      width: 83.33333333333334%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg9 {
      width: 75%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg8 {
      width: 66.66666666666666%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg7 {
      width: 58.333333333333336%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg6 {
      width: 50%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg5 {
      width: 41.66666666666667%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg4 {
      width: 33.33333333333333%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg3 {
      width: 25%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg2 {
      width: 16.666666666666664%;
    }
  }

  @media (min-width: 640px) {
    .ms-lg1 {
      width: 8.333333333333332%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull12 {
      right: 100%;
    }

    [dir="rtl"] .ms-lgPull12 {
      left: 100%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull11 {
      right: 91.66667%;
    }

    [dir="rtl"] .ms-lgPull11 {
      left: 91.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull10 {
      right: 83.33333%;
    }

    [dir="rtl"] .ms-lgPull10 {
      left: 83.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull9 {
      right: 75%;
    }

    [dir="rtl"] .ms-lgPull9 {
      left: 75%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull8 {
      right: 66.66667%;
    }

    [dir="rtl"] .ms-lgPull8 {
      left: 66.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull7 {
      right: 58.33333%;
    }

    [dir="rtl"] .ms-lgPull7 {
      left: 58.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull6 {
      right: 50%;
    }

    [dir="rtl"] .ms-lgPull6 {
      left: 50%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull5 {
      right: 41.66667%;
    }

    [dir="rtl"] .ms-lgPull5 {
      left: 41.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull4 {
      right: 33.33333%;
    }

    [dir="rtl"] .ms-lgPull4 {
      left: 33.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull3 {
      right: 25%;
    }

    [dir="rtl"] .ms-lgPull3 {
      left: 25%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull2 {
      right: 16.66667%;
    }

    [dir="rtl"] .ms-lgPull2 {
      left: 16.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull1 {
      right: 8.33333%;
    }

    [dir="rtl"] .ms-lgPull1 {
      left: 8.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPull0 {
      right: auto;
    }

    [dir="rtl"] .ms-lgPull0 {
      left: auto;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush12 {
      left: 100%;
    }

    [dir="rtl"] .ms-lgPush12 {
      right: 100%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush11 {
      left: 91.66667%;
    }

    [dir="rtl"] .ms-lgPush11 {
      right: 91.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush10 {
      left: 83.33333%;
    }

    [dir="rtl"] .ms-lgPush10 {
      right: 83.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush9 {
      left: 75%;
    }

    [dir="rtl"] .ms-lgPush9 {
      right: 75%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush8 {
      left: 66.66667%;
    }

    [dir="rtl"] .ms-lgPush8 {
      right: 66.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush7 {
      left: 58.33333%;
    }

    [dir="rtl"] .ms-lgPush7 {
      right: 58.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush6 {
      left: 50%;
    }

    [dir="rtl"] .ms-lgPush6 {
      right: 50%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush5 {
      left: 41.66667%;
    }

    [dir="rtl"] .ms-lgPush5 {
      right: 41.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush4 {
      left: 33.33333%;
    }

    [dir="rtl"] .ms-lgPush4 {
      right: 33.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush3 {
      left: 25%;
    }

    [dir="rtl"] .ms-lgPush3 {
      right: 25%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush2 {
      left: 16.66667%;
    }

    [dir="rtl"] .ms-lgPush2 {
      right: 16.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush1 {
      left: 8.33333%;
    }

    [dir="rtl"] .ms-lgPush1 {
      right: 8.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgPush0 {
      left: auto;
    }

    [dir="rtl"] .ms-lgPush0 {
      right: auto;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset11 {
      margin-left: 91.66667%;
    }

    [dir="rtl"] .ms-lgOffset11 {
      margin-right: 91.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset10 {
      margin-left: 83.33333%;
    }

    [dir="rtl"] .ms-lgOffset10 {
      margin-right: 83.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset9 {
      margin-left: 75%;
    }

    [dir="rtl"] .ms-lgOffset9 {
      margin-right: 75%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset8 {
      margin-left: 66.66667%;
    }

    [dir="rtl"] .ms-lgOffset8 {
      margin-right: 66.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset7 {
      margin-left: 58.33333%;
    }

    [dir="rtl"] .ms-lgOffset7 {
      margin-right: 58.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset6 {
      margin-left: 50%;
    }

    [dir="rtl"] .ms-lgOffset6 {
      margin-right: 50%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset5 {
      margin-left: 41.66667%;
    }

    [dir="rtl"] .ms-lgOffset5 {
      margin-right: 41.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset4 {
      margin-left: 33.33333%;
    }

    [dir="rtl"] .ms-lgOffset4 {
      margin-right: 33.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset3 {
      margin-left: 25%;
    }

    [dir="rtl"] .ms-lgOffset3 {
      margin-right: 25%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset2 {
      margin-left: 16.66667%;
    }

    [dir="rtl"] .ms-lgOffset2 {
      margin-right: 16.66667%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset1 {
      margin-left: 8.33333%;
    }

    [dir="rtl"] .ms-lgOffset1 {
      margin-right: 8.33333%;
    }
  }

  @media (min-width: 640px) {
    [dir="ltr"] .ms-lgOffset0 {
      margin-left: 0;
    }

    [dir="rtl"] .ms-lgOffset0 {
      margin-right: 0;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl12 {
      width: 100%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl11 {
      width: 91.66666666666666%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl10 {
      width: 83.33333333333334%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl9 {
      width: 75%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl8 {
      width: 66.66666666666666%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl7 {
      width: 58.333333333333336%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl6 {
      width: 50%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl5 {
      width: 41.66666666666667%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl4 {
      width: 33.33333333333333%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl3 {
      width: 25%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl2 {
      width: 16.666666666666664%;
    }
  }

  @media (min-width: 1024px) {
    .ms-xl1 {
      width: 8.333333333333332%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull12 {
      right: 100%;
    }

    [dir="rtl"] .ms-xlPull12 {
      left: 100%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull11 {
      right: 91.66667%;
    }

    [dir="rtl"] .ms-xlPull11 {
      left: 91.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull10 {
      right: 83.33333%;
    }

    [dir="rtl"] .ms-xlPull10 {
      left: 83.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull9 {
      right: 75%;
    }

    [dir="rtl"] .ms-xlPull9 {
      left: 75%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull8 {
      right: 66.66667%;
    }

    [dir="rtl"] .ms-xlPull8 {
      left: 66.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull7 {
      right: 58.33333%;
    }

    [dir="rtl"] .ms-xlPull7 {
      left: 58.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull6 {
      right: 50%;
    }

    [dir="rtl"] .ms-xlPull6 {
      left: 50%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull5 {
      right: 41.66667%;
    }

    [dir="rtl"] .ms-xlPull5 {
      left: 41.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull4 {
      right: 33.33333%;
    }

    [dir="rtl"] .ms-xlPull4 {
      left: 33.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull3 {
      right: 25%;
    }

    [dir="rtl"] .ms-xlPull3 {
      left: 25%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull2 {
      right: 16.66667%;
    }

    [dir="rtl"] .ms-xlPull2 {
      left: 16.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull1 {
      right: 8.33333%;
    }

    [dir="rtl"] .ms-xlPull1 {
      left: 8.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPull0 {
      right: auto;
    }

    [dir="rtl"] .ms-xlPull0 {
      left: auto;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush12 {
      left: 100%;
    }

    [dir="rtl"] .ms-xlPush12 {
      right: 100%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush11 {
      left: 91.66667%;
    }

    [dir="rtl"] .ms-xlPush11 {
      right: 91.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush10 {
      left: 83.33333%;
    }

    [dir="rtl"] .ms-xlPush10 {
      right: 83.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush9 {
      left: 75%;
    }

    [dir="rtl"] .ms-xlPush9 {
      right: 75%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush8 {
      left: 66.66667%;
    }

    [dir="rtl"] .ms-xlPush8 {
      right: 66.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush7 {
      left: 58.33333%;
    }

    [dir="rtl"] .ms-xlPush7 {
      right: 58.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush6 {
      left: 50%;
    }

    [dir="rtl"] .ms-xlPush6 {
      right: 50%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush5 {
      left: 41.66667%;
    }

    [dir="rtl"] .ms-xlPush5 {
      right: 41.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush4 {
      left: 33.33333%;
    }

    [dir="rtl"] .ms-xlPush4 {
      right: 33.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush3 {
      left: 25%;
    }

    [dir="rtl"] .ms-xlPush3 {
      right: 25%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush2 {
      left: 16.66667%;
    }

    [dir="rtl"] .ms-xlPush2 {
      right: 16.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush1 {
      left: 8.33333%;
    }

    [dir="rtl"] .ms-xlPush1 {
      right: 8.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlPush0 {
      left: auto;
    }

    [dir="rtl"] .ms-xlPush0 {
      right: auto;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset11 {
      margin-left: 91.66667%;
    }

    [dir="rtl"] .ms-xlOffset11 {
      margin-right: 91.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset10 {
      margin-left: 83.33333%;
    }

    [dir="rtl"] .ms-xlOffset10 {
      margin-right: 83.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset9 {
      margin-left: 75%;
    }

    [dir="rtl"] .ms-xlOffset9 {
      margin-right: 75%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset8 {
      margin-left: 66.66667%;
    }

    [dir="rtl"] .ms-xlOffset8 {
      margin-right: 66.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset7 {
      margin-left: 58.33333%;
    }

    [dir="rtl"] .ms-xlOffset7 {
      margin-right: 58.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset6 {
      margin-left: 50%;
    }

    [dir="rtl"] .ms-xlOffset6 {
      margin-right: 50%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset5 {
      margin-left: 41.66667%;
    }

    [dir="rtl"] .ms-xlOffset5 {
      margin-right: 41.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset4 {
      margin-left: 33.33333%;
    }

    [dir="rtl"] .ms-xlOffset4 {
      margin-right: 33.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset3 {
      margin-left: 25%;
    }

    [dir="rtl"] .ms-xlOffset3 {
      margin-right: 25%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset2 {
      margin-left: 16.66667%;
    }

    [dir="rtl"] .ms-xlOffset2 {
      margin-right: 16.66667%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset1 {
      margin-left: 8.33333%;
    }

    [dir="rtl"] .ms-xlOffset1 {
      margin-right: 8.33333%;
    }
  }

  @media (min-width: 1024px) {
    [dir="ltr"] .ms-xlOffset0 {
      margin-left: 0;
    }

    [dir="rtl"] .ms-xlOffset0 {
      margin-right: 0;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl12 {
      width: 100%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl11 {
      width: 91.66666666666666%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl10 {
      width: 83.33333333333334%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl9 {
      width: 75%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl8 {
      width: 66.66666666666666%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl7 {
      width: 58.333333333333336%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl6 {
      width: 50%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl5 {
      width: 41.66666666666667%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl4 {
      width: 33.33333333333333%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl3 {
      width: 25%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl2 {
      width: 16.666666666666664%;
    }
  }

  @media (min-width: 1366px) {
    .ms-xxl1 {
      width: 8.333333333333332%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull12 {
      right: 100%;
    }

    [dir="rtl"] .ms-xxlPull12 {
      left: 100%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull11 {
      right: 91.66667%;
    }

    [dir="rtl"] .ms-xxlPull11 {
      left: 91.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull10 {
      right: 83.33333%;
    }

    [dir="rtl"] .ms-xxlPull10 {
      left: 83.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull9 {
      right: 75%;
    }

    [dir="rtl"] .ms-xxlPull9 {
      left: 75%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull8 {
      right: 66.66667%;
    }

    [dir="rtl"] .ms-xxlPull8 {
      left: 66.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull7 {
      right: 58.33333%;
    }

    [dir="rtl"] .ms-xxlPull7 {
      left: 58.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull6 {
      right: 50%;
    }

    [dir="rtl"] .ms-xxlPull6 {
      left: 50%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull5 {
      right: 41.66667%;
    }

    [dir="rtl"] .ms-xxlPull5 {
      left: 41.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull4 {
      right: 33.33333%;
    }

    [dir="rtl"] .ms-xxlPull4 {
      left: 33.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull3 {
      right: 25%;
    }

    [dir="rtl"] .ms-xxlPull3 {
      left: 25%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull2 {
      right: 16.66667%;
    }

    [dir="rtl"] .ms-xxlPull2 {
      left: 16.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull1 {
      right: 8.33333%;
    }

    [dir="rtl"] .ms-xxlPull1 {
      left: 8.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPull0 {
      right: auto;
    }

    [dir="rtl"] .ms-xxlPull0 {
      left: auto;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush12 {
      left: 100%;
    }

    [dir="rtl"] .ms-xxlPush12 {
      right: 100%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush11 {
      left: 91.66667%;
    }

    [dir="rtl"] .ms-xxlPush11 {
      right: 91.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush10 {
      left: 83.33333%;
    }

    [dir="rtl"] .ms-xxlPush10 {
      right: 83.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush9 {
      left: 75%;
    }

    [dir="rtl"] .ms-xxlPush9 {
      right: 75%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush8 {
      left: 66.66667%;
    }

    [dir="rtl"] .ms-xxlPush8 {
      right: 66.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush7 {
      left: 58.33333%;
    }

    [dir="rtl"] .ms-xxlPush7 {
      right: 58.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush6 {
      left: 50%;
    }

    [dir="rtl"] .ms-xxlPush6 {
      right: 50%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush5 {
      left: 41.66667%;
    }

    [dir="rtl"] .ms-xxlPush5 {
      right: 41.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush4 {
      left: 33.33333%;
    }

    [dir="rtl"] .ms-xxlPush4 {
      right: 33.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush3 {
      left: 25%;
    }

    [dir="rtl"] .ms-xxlPush3 {
      right: 25%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush2 {
      left: 16.66667%;
    }

    [dir="rtl"] .ms-xxlPush2 {
      right: 16.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush1 {
      left: 8.33333%;
    }

    [dir="rtl"] .ms-xxlPush1 {
      right: 8.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlPush0 {
      left: auto;
    }

    [dir="rtl"] .ms-xxlPush0 {
      right: auto;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset11 {
      margin-left: 91.66667%;
    }

    [dir="rtl"] .ms-xxlOffset11 {
      margin-right: 91.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset10 {
      margin-left: 83.33333%;
    }

    [dir="rtl"] .ms-xxlOffset10 {
      margin-right: 83.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset9 {
      margin-left: 75%;
    }

    [dir="rtl"] .ms-xxlOffset9 {
      margin-right: 75%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset8 {
      margin-left: 66.66667%;
    }

    [dir="rtl"] .ms-xxlOffset8 {
      margin-right: 66.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset7 {
      margin-left: 58.33333%;
    }

    [dir="rtl"] .ms-xxlOffset7 {
      margin-right: 58.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset6 {
      margin-left: 50%;
    }

    [dir="rtl"] .ms-xxlOffset6 {
      margin-right: 50%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset5 {
      margin-left: 41.66667%;
    }

    [dir="rtl"] .ms-xxlOffset5 {
      margin-right: 41.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset4 {
      margin-left: 33.33333%;
    }

    [dir="rtl"] .ms-xxlOffset4 {
      margin-right: 33.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset3 {
      margin-left: 25%;
    }

    [dir="rtl"] .ms-xxlOffset3 {
      margin-right: 25%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset2 {
      margin-left: 16.66667%;
    }

    [dir="rtl"] .ms-xxlOffset2 {
      margin-right: 16.66667%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset1 {
      margin-left: 8.33333%;
    }

    [dir="rtl"] .ms-xxlOffset1 {
      margin-right: 8.33333%;
    }
  }

  @media (min-width: 1366px) {
    [dir="ltr"] .ms-xxlOffset0 {
      margin-left: 0;
    }

    [dir="rtl"] .ms-xxlOffset0 {
      margin-right: 0;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl12 {
      width: 100%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl11 {
      width: 91.66666666666666%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl10 {
      width: 83.33333333333334%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl9 {
      width: 75%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl8 {
      width: 66.66666666666666%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl7 {
      width: 58.333333333333336%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl6 {
      width: 50%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl5 {
      width: 41.66666666666667%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl4 {
      width: 33.33333333333333%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl3 {
      width: 25%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl2 {
      width: 16.666666666666664%;
    }
  }

  @media (min-width: 1920px) {
    .ms-xxxl1 {
      width: 8.333333333333332%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull12 {
      right: 100%;
    }

    [dir="rtl"] .ms-xxxlPull12 {
      left: 100%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull11 {
      right: 91.66667%;
    }

    [dir="rtl"] .ms-xxxlPull11 {
      left: 91.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull10 {
      right: 83.33333%;
    }

    [dir="rtl"] .ms-xxxlPull10 {
      left: 83.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull9 {
      right: 75%;
    }

    [dir="rtl"] .ms-xxxlPull9 {
      left: 75%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull8 {
      right: 66.66667%;
    }

    [dir="rtl"] .ms-xxxlPull8 {
      left: 66.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull7 {
      right: 58.33333%;
    }

    [dir="rtl"] .ms-xxxlPull7 {
      left: 58.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull6 {
      right: 50%;
    }

    [dir="rtl"] .ms-xxxlPull6 {
      left: 50%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull5 {
      right: 41.66667%;
    }

    [dir="rtl"] .ms-xxxlPull5 {
      left: 41.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull4 {
      right: 33.33333%;
    }

    [dir="rtl"] .ms-xxxlPull4 {
      left: 33.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull3 {
      right: 25%;
    }

    [dir="rtl"] .ms-xxxlPull3 {
      left: 25%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull2 {
      right: 16.66667%;
    }

    [dir="rtl"] .ms-xxxlPull2 {
      left: 16.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull1 {
      right: 8.33333%;
    }

    [dir="rtl"] .ms-xxxlPull1 {
      left: 8.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPull0 {
      right: auto;
    }

    [dir="rtl"] .ms-xxxlPull0 {
      left: auto;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush12 {
      left: 100%;
    }

    [dir="rtl"] .ms-xxxlPush12 {
      right: 100%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush11 {
      left: 91.66667%;
    }

    [dir="rtl"] .ms-xxxlPush11 {
      right: 91.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush10 {
      left: 83.33333%;
    }

    [dir="rtl"] .ms-xxxlPush10 {
      right: 83.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush9 {
      left: 75%;
    }

    [dir="rtl"] .ms-xxxlPush9 {
      right: 75%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush8 {
      left: 66.66667%;
    }

    [dir="rtl"] .ms-xxxlPush8 {
      right: 66.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush7 {
      left: 58.33333%;
    }

    [dir="rtl"] .ms-xxxlPush7 {
      right: 58.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush6 {
      left: 50%;
    }

    [dir="rtl"] .ms-xxxlPush6 {
      right: 50%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush5 {
      left: 41.66667%;
    }

    [dir="rtl"] .ms-xxxlPush5 {
      right: 41.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush4 {
      left: 33.33333%;
    }

    [dir="rtl"] .ms-xxxlPush4 {
      right: 33.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush3 {
      left: 25%;
    }

    [dir="rtl"] .ms-xxxlPush3 {
      right: 25%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush2 {
      left: 16.66667%;
    }

    [dir="rtl"] .ms-xxxlPush2 {
      right: 16.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush1 {
      left: 8.33333%;
    }

    [dir="rtl"] .ms-xxxlPush1 {
      right: 8.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlPush0 {
      left: auto;
    }

    [dir="rtl"] .ms-xxxlPush0 {
      right: auto;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset11 {
      margin-left: 91.66667%;
    }

    [dir="rtl"] .ms-xxxlOffset11 {
      margin-right: 91.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset10 {
      margin-left: 83.33333%;
    }

    [dir="rtl"] .ms-xxxlOffset10 {
      margin-right: 83.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset9 {
      margin-left: 75%;
    }

    [dir="rtl"] .ms-xxxlOffset9 {
      margin-right: 75%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset8 {
      margin-left: 66.66667%;
    }

    [dir="rtl"] .ms-xxxlOffset8 {
      margin-right: 66.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset7 {
      margin-left: 58.33333%;
    }

    [dir="rtl"] .ms-xxxlOffset7 {
      margin-right: 58.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset6 {
      margin-left: 50%;
    }

    [dir="rtl"] .ms-xxxlOffset6 {
      margin-right: 50%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset5 {
      margin-left: 41.66667%;
    }

    [dir="rtl"] .ms-xxxlOffset5 {
      margin-right: 41.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset4 {
      margin-left: 33.33333%;
    }

    [dir="rtl"] .ms-xxxlOffset4 {
      margin-right: 33.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset3 {
      margin-left: 25%;
    }

    [dir="rtl"] .ms-xxxlOffset3 {
      margin-right: 25%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset2 {
      margin-left: 16.66667%;
    }

    [dir="rtl"] .ms-xxxlOffset2 {
      margin-right: 16.66667%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset1 {
      margin-left: 8.33333%;
    }

    [dir="rtl"] .ms-xxxlOffset1 {
      margin-right: 8.33333%;
    }
  }

  @media (min-width: 1920px) {
    [dir="ltr"] .ms-xxxlOffset0 {
      margin-left: 0;
    }

    [dir="rtl"] .ms-xxxlOffset0 {
      margin-right: 0;
    }
  }

  .ms-borderBox,
  .ms-borderBox::before,
  .ms-borderBox::after {
    box-sizing: border-box;
  }

  .ms-borderBase {
    border: 1px solid;
  }

  .ms-clearfix {
    zoom: 1;
  }

  .ms-clearfix::before,
  .ms-clearfix::after {
    display: table;
    content: "";
    line-height: 0;
  }

  .ms-clearfix::after {
    clear: both;
  }

  .ms-normalize {
    box-sizing: border-box;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  [dir="ltr"] .ms-textAlignLeft {
    text-align: left;
  }

  [dir="rtl"] .ms-textAlignLeft {
    text-align: right;
  }

  [dir="ltr"] .ms-textAlignRight {
    text-align: right;
  }

  [dir="rtl"] .ms-textAlignRight {
    text-align: left;
  }

  .ms-textAlignCenter {
    text-align: center;
  }

  .ms-screenReaderOnly {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .ms-textTruncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
  }

  .ms-noWrap {
    white-space: nowrap;
  }

  .ms-Fabric {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    color: #323130;
    font-family: "Segoe UI Web (West European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
    font-size: 14px;
  }

  .ms-Fabric button,
  .ms-Fabric input,
  .ms-Fabric textarea {
    font-family: inherit;
  }

  *[lang^="ar"] .ms-Fabric,
  .ms-Fabric *[lang^="ar"],
  .ms-Fabric[lang^="ar"] {
    font-family: "Segoe UI Web (Arabic)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="bg"] .ms-Fabric,
  .ms-Fabric *[lang^="bg"],
  .ms-Fabric[lang^="bg"] {
    font-family: "Segoe UI Web (Cyrillic)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="cs"] .ms-Fabric,
  .ms-Fabric *[lang^="cs"],
  .ms-Fabric[lang^="cs"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="el"] .ms-Fabric,
  .ms-Fabric *[lang^="el"],
  .ms-Fabric[lang^="el"] {
    font-family: "Segoe UI Web (Greek)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="et"] .ms-Fabric,
  .ms-Fabric *[lang^="et"],
  .ms-Fabric[lang^="et"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="he"] .ms-Fabric,
  .ms-Fabric *[lang^="he"],
  .ms-Fabric[lang^="he"] {
    font-family: "Segoe UI Web (Hebrew)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="hi"] .ms-Fabric,
  .ms-Fabric *[lang^="hi"],
  .ms-Fabric[lang^="hi"] {
    font-family: "Nirmala UI", "Segoe UI", -apple-system, BlinkMacSystemFont,
      "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="hr"] .ms-Fabric,
  .ms-Fabric *[lang^="hr"],
  .ms-Fabric[lang^="hr"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="hu"] .ms-Fabric,
  .ms-Fabric *[lang^="hu"],
  .ms-Fabric[lang^="hu"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="ja"] .ms-Fabric,
  .ms-Fabric *[lang^="ja"],
  .ms-Fabric[lang^="ja"] {
    font-family: "Yu Gothic UI", "Meiryo UI", Meiryo, "MS Pgothic", Osaka,
      "Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue",
      sans-serif;
  }

  *[lang^="kk"] .ms-Fabric,
  .ms-Fabric *[lang^="kk"],
  .ms-Fabric[lang^="kk"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="ko"] .ms-Fabric,
  .ms-Fabric *[lang^="ko"],
  .ms-Fabric[lang^="ko"] {
    font-family: "Malgun Gothic", Gulim, "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="lo"] .ms-Fabric,
  .ms-Fabric *[lang^="lo"],
  .ms-Fabric[lang^="lo"] {
    font-family: "Leelawadee UI Web", "Lao UI", DokChampa, "Segoe UI",
      -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="lt"] .ms-Fabric,
  .ms-Fabric *[lang^="lt"],
  .ms-Fabric[lang^="lt"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="lv"] .ms-Fabric,
  .ms-Fabric *[lang^="lv"],
  .ms-Fabric[lang^="lv"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="pl"] .ms-Fabric,
  .ms-Fabric *[lang^="pl"],
  .ms-Fabric[lang^="pl"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="ru"] .ms-Fabric,
  .ms-Fabric *[lang^="ru"],
  .ms-Fabric[lang^="ru"] {
    font-family: "Segoe UI Web (Cyrillic)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="sk"] .ms-Fabric,
  .ms-Fabric *[lang^="sk"],
  .ms-Fabric[lang^="sk"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="sr-latn"] .ms-Fabric,
  .ms-Fabric *[lang^="sr-latn"],
  .ms-Fabric[lang^="sr-latn"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="th"] .ms-Fabric,
  .ms-Fabric *[lang^="th"],
  .ms-Fabric[lang^="th"] {
    font-family: "Leelawadee UI Web", "Kmer UI", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="tr"] .ms-Fabric,
  .ms-Fabric *[lang^="tr"],
  .ms-Fabric[lang^="tr"] {
    font-family: "Segoe UI Web (East European)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="uk"] .ms-Fabric,
  .ms-Fabric *[lang^="uk"],
  .ms-Fabric[lang^="uk"] {
    font-family: "Segoe UI Web (Cyrillic)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="vi"] .ms-Fabric,
  .ms-Fabric *[lang^="vi"],
  .ms-Fabric[lang^="vi"] {
    font-family: "Segoe UI Web (Vietnamese)", "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="zh-hans"] .ms-Fabric,
  .ms-Fabric *[lang^="zh-hans"],
  .ms-Fabric[lang^="zh-hans"] {
    font-family: "Microsoft Yahei UI", Verdana, Simsun, "Segoe UI",
      -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  *[lang^="zh-hant"] .ms-Fabric,
  .ms-Fabric *[lang^="zh-hant"],
  .ms-Fabric[lang^="zh-hant"] {
    font-family: "Microsoft Jhenghei UI", Pmingliu, "Segoe UI", -apple-system,
      BlinkMacSystemFont, "Roboto", "Helvetica Neue", sans-serif;
  }

  .ms-Fabric--selawik {
    font-family: "Selawik Web", "Segoe UI", -apple-system, BlinkMacSystemFont,
      "Roboto", "Helvetica Neue", sans-serif;
  }
`;

export const TabListWrapper = styled.div<{$theme?: string}>`
  position: fixed;
  bottom: 0;
  width: 100%;
  color: ${props => renderColorByTheme(props.$theme)};
  background-color: ${props => renderBackgroundColorByTheme(props.$theme)};
  left: 0;
  z-index: 99999;
  height: 40px;
`;
